import React from "react";
import { Disclosure, DisclosurePanel } from "react-aria-components";

import type { HeadingBlock } from "@reactivated";

import { Clickable } from "../Clickables";

import styles from "./DisclosureRow.module.scss";

export type HeadingTag = Exclude<NonNullable<HeadingBlock["tag"]>, "p">;

interface Props {
    title: React.ReactNode;
    headingTag: HeadingTag;
    children: React.ReactNode;
}

export const DisclosureRow = ({
    title,
    headingTag: HeadingTag,
    children,
}: Props) => (
    <Disclosure className={styles.item}>
        <HeadingTag>
            <Clickable slot="trigger" className={styles.trigger}>
                <span className={styles.title}>{title}</span>
                <span className={styles.toggle} aria-hidden="true" />
            </Clickable>
        </HeadingTag>
        <DisclosurePanel className={styles.panel}>
            <div className={styles.panelInner}>{children}</div>
        </DisclosurePanel>
    </Disclosure>
);
